import React from 'react';
import { connect } from 'react-redux';
import User from './User';
import { getLocationFromState } from '../../utils/locationUtils';

const UserComponent = connect(
    function mapStateToProps(state) {
        const user = state.user || {};
        const publisher = user.publisher || {};
        const account = publisher.account || {};
        const balance = account.balance || {};

        return {
            location: getLocationFromState(state),
            balanceAmount: balance.amount,
            holdBalance: account.hold_balance,
            payoutBalance: account.payout_balance,
            currency: balance.currency,
            email: user.email,
            timezone: user.timezone,
            name: publisher.name,
            publisherIsReferral: publisher.referral_publisher
        };
    },
    function mapDispatchToProps(dispatch) {
        return {};
    }
)(User);

export default UserComponent;
